<div class="modal-body">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('modalHeader')}} - {{templateName}}
    </span>

    <div class="content layout-auto-1-auto width-700">

      <div *ngIf="isLoading" class="splash loading">
        <div class="spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div *ngIf="!isLoading" class="content">

        <p class="typo-inline-info">
          <i class="far fa-info-circle"></i>
          <span>{{existingCalculations.length === 0 ?
            getRessource('noExistingCalculations') : getRessource('selectCalculationInfo')}}
          </span>
        </p>

        <div></div>
        <div></div>

        <div *ngIf="existingCalculations.length > 0" class="content height-400">
          <exg-data-list
            selectKey="cvID"
            [allowSingleSelection]="true"
            [rowSource]="existingCalculations"
            (RowChange)="selectCalculation(existingCalculations[$event])">

            <ng-template #rowTemplate let-calc>
              <div class="list-row list-single-line-auto-1 typo-small">
                <div>
                  <div><strong>{{calc.cvName}}</strong></div>
                  <div class="list-secondary-text" *ngIf="calc.cvDescription">
                    {{calc.cvDescription}}
                  </div>
                  <div class="list-metadata">
                  {{getRessource('created')}}: {{calc.cvCRU}} {{calc.cvCRD | excDate: getGlobal('DateTimeFormatShort')}}
                  </div>
                </div>
              </div>
            </ng-template>
          </exg-data-list>
        </div>

      </div>
    </div>

    <div class="spawn-modal-actions typo-small">
      <button *ngIf="selectedCalculation && !isLoading"
              (click)="openSelectedCalculation()"
              class="md-btn">
        {{getRessource('useAsTemplate')}}
      </button>

      <button *ngIf="!isLoading"
              (click)="createNewCalculation()"
              class="md-btn">
        {{getRessource('createNewCalculation')}}
      </button>

      <button (click)="close()" class="md-btn">
        {{getGlobal('Close')}}
      </button>
    </div>
  </div>
</div>
